export const SYNC_GUEST_CARD_REQUEST = 'SYNC_GUEST_CARD_REQUEST';
export const SYNC_GUEST_CARD_SUCCESS = 'SYNC_GUEST_CARD_SUCCESS';
export const SYNC_GUEST_CARD_FAILURE = 'SYNC_GUEST_CARD_FAILURE';

export const CLEAR_SYNC_GUEST_CARD_MESSAGE = 'CLEAR_SYNC_GUEST_CARD_MESSAGE';
